import React from 'react'
import {CalendarOutlined, CaretDownOutlined, SwapOutlined} from "@ant-design/icons";
import { Button , Card } from 'antd';
import { useState } from 'react';
import { Calendar } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const AvailableTrip = () => {

      const [ isDateOpen , setIsDateOpen ] = useState(false);
      const [ returnDateOpen , setReturnDateOpen ] = useState(false);
      const [date, setDate] = useState(new Date());
      const [returnDate, setreturnDate] = useState(new Date());
    
      const onDateChange = (e) => {
        setDate(e);
        setIsDateOpen(false);
      }
      const onReturnDateChange = (e) => {
        setreturnDate(e);
        setReturnDateOpen(false);
      }

  return (
    <div>
  <Card>

       <div className="available_bus">
          <div className="available_bg">

            <div className="availabel_inputs">
               <div className="trip_inputs_box">
                  <label>From : </label>
                 
                  <select>
                    <option selected disabled >Select</option>
                    <option value={'Delhi'}>Delhi</option>
                    <option value={'Pune'}>Pune</option>
                    <option value={'Mumbai'}>Mumbai</option>
                    <option value={'Agra'}>Agra</option>
                    <option value={'Mathura'}>Mathura</option>
                  </select>
               </div>              
                  <div class="center_icon">
                      <SwapOutlined />  
                  </div>
              <div className="trip_inputs_box">
                  <label>To : </label>
                  
                  <select>
                    <option selected disabled >Select</option>
                    <option value={'Delhi'}>Delhi</option>
                    <option value={'Pune'}>Pune</option>
                    <option value={'Mumbai'}>Mumbai</option>
                    <option value={'Agra'}>Agra</option>
                    <option value={'Mathura'}>Mathura</option>
                  </select>
              </div>                           
            </div>          
            <div className="avialabel_date">
                <p>Departure Date</p>
                <Button onClick={() => setIsDateOpen(!isDateOpen)}><CalendarOutlined /> {date.toDateString()} </Button>
                {isDateOpen && <Calendar onChange={onDateChange} value={date} />}
           </div> 
           <div className="avialabel_date">
                <p>Return date</p>
                <Button onClick={() => setReturnDateOpen(!returnDateOpen)}><CalendarOutlined /> {returnDate.toDateString()} </Button>
                {returnDateOpen && <Calendar onChange={onReturnDateChange} value={returnDate} />}
           </div> 

            
           <div class="view_bus_detail">
                    Edit Search
            </div> 

        </div>
       
        
       </div>
       
       </Card>

       <Card className='availabel_card_box'>
            <div className='availabel_step'>
                <div className='f4erg'>
                    <h4>Mahrani Travels</h4>
                    <p>AC Seater/Sleeper 2+1</p>
                </div>
                <div class="_0BTrK">
                    <div class="wYtCy">
                        <div class="_4rWgi">11:30 PM</div>
                        <div class="C3vrs">18 Apr</div>
                    </div>
                    <div className='Ox7H'>
                            <div class="Ou4vr"></div>
                                <div class="_1D2hF">06h 15m</div>
                            <div class="Ou4vr"></div>
                    </div>
                    <div class="EjC2U">
                        <div class="_4rWgi">05:45 AM</div>
                        <div class="C3vrs">19 Apr</div>
                    </div>
                </div>
                <div className='M9WQW'>
                    <span>₹&ensp;550</span>
                </div>
            </div>

            <div class="view_details">
            <div class="view_bus_detail">
                View Bus Details<span><CaretDownOutlined /></span>
            </div>
            <div class="tHD3b">
                <div class="UxGbP">2 single seats</div>
                <div class="haY1b">|</div>
                <div class="UxGbP">42 seats left</div>
                <div class="q36kN">Select Seat</div>
            </div>
            </div>
       </Card>

    </div>
  )
}

export default AvailableTrip